module.exports = __webpack_public_path__ + "img/class-group.a78179c7.png";